import { levelToProgress } from '../lib/CurriculumManager';
import gameNames from '../../hub/data/GameIds';

export const initialState = 0;

const progress = (state = initialState, action) => {
  if (action.gameId !== gameNames.WORDBOTS) {
    return state;
  }

  switch (action.type) {
    case 'WORDBOTS_INCREMENT_PROGRESS':
      return action.payload;

    case 'WORDBOTS_GO_TO_LEVEL':
      return levelToProgress(action.payload.level);

    default:
      return state;
  }
};

export default progress;
